export const TRANSMITTAL = {};

//-------------------------------------------------------------------
TRANSMITTAL.UPDATE_WAITING_TRANSMITTAL_LIST ="UPDATE_WAITING_TRANSMITTAL_LIST";
//-------------------------------------------------------------------
TRANSMITTAL.UPDATE_SELECTED_PEND_TR ="UPDATE_SELECTED_PEND_TR";
//-------------------------------------------------------------------
TRANSMITTAL.EDIT_DOCLIST_MODAL = "EDIT_DOCLIST_MODAL";
//--------------------------------------------------------------------
TRANSMITTAL.UPDATE_SELECTED_REV_LIST ="UPDATE_SELECTED_REV_LIST";
//--------------------------------------------------------------------
TRANSMITTAL.UPDATE_REGISTERED_TR_LIST ="UPDATE_REGISTERED_TR_LIST";
//--------------------------------------------------------------------
TRANSMITTAL.UPDATE_TR_SEARCH ="UPDATE_TR_SEARCH";
